import _slicedToArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
// Config settings
var cacheSettings = {
  // Consider a fetch stale after 1 minute
  staleTTL: 1000 * 60,
  // Max time to keep a fetch in cache (24 hours default)
  maxAge: 1000 * 60 * 60 * 24,
  cacheKey: "gbFeaturesCache",
  backgroundSync: true,
  maxEntries: 10,
  disableIdleStreams: false,
  idleStreamInterval: 20000
};
var polyfills = {
  fetch: globalThis.fetch ? globalThis.fetch.bind(globalThis) : undefined,
  SubtleCrypto: globalThis.crypto ? globalThis.crypto.subtle : undefined,
  EventSource: globalThis.EventSource
};
export var helpers = {
  fetchFeaturesCall: function fetchFeaturesCall(_ref) {
    var host = _ref.host,
      clientKey = _ref.clientKey,
      headers = _ref.headers;
    return polyfills.fetch("".concat(host, "/api/features/").concat(clientKey), {
      headers: headers
    });
  },
  fetchRemoteEvalCall: function fetchRemoteEvalCall(_ref2) {
    var host = _ref2.host,
      clientKey = _ref2.clientKey,
      payload = _ref2.payload,
      headers = _ref2.headers;
    var options = {
      method: "POST",
      headers: _objectSpread({
        "Content-Type": "application/json"
      }, headers),
      body: JSON.stringify(payload)
    };
    return polyfills.fetch("".concat(host, "/api/eval/").concat(clientKey), options);
  },
  eventSourceCall: function eventSourceCall(_ref3) {
    var host = _ref3.host,
      clientKey = _ref3.clientKey,
      headers = _ref3.headers;
    if (headers) {
      return new polyfills.EventSource("".concat(host, "/sub/").concat(clientKey), {
        headers: headers
      });
    }
    return new polyfills.EventSource("".concat(host, "/sub/").concat(clientKey));
  },
  startIdleListener: function startIdleListener() {
    var idleTimeout;
    var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
    if (!isBrowser) return;
    var onVisibilityChange = function onVisibilityChange() {
      if (document.visibilityState === "visible") {
        window.clearTimeout(idleTimeout);
        onVisible();
      } else if (document.visibilityState === "hidden") {
        idleTimeout = window.setTimeout(onHidden, cacheSettings.idleStreamInterval);
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return function () {
      return document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  },
  stopIdleListener: function stopIdleListener() {
    // No-op, replaced by startIdleListener
  }
};
try {
  if (globalThis.localStorage) {
    polyfills.localStorage = globalThis.localStorage;
  }
} catch (e) {
  // Ignore localStorage errors
}

// Global state
var subscribedInstances = new Map();
var cacheInitialized = false;
var cache = new Map();
var activeFetches = new Map();
var streams = new Map();
var supportsSSE = new Set();

// Public functions
export function setPolyfills(overrides) {
  Object.assign(polyfills, overrides);
}
export function configureCache(overrides) {
  Object.assign(cacheSettings, overrides);
  if (!cacheSettings.backgroundSync) {
    clearAutoRefresh();
  }
}
export function clearCache() {
  return _clearCache.apply(this, arguments);
}
function _clearCache() {
  _clearCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cache.clear();
          activeFetches.clear();
          clearAutoRefresh();
          cacheInitialized = false;
          _context.next = 6;
          return updatePersistentCache();
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _clearCache.apply(this, arguments);
}
export function refreshFeatures(_x, _x2, _x3, _x4, _x5, _x6) {
  return _refreshFeatures.apply(this, arguments);
}

// Subscribe a GrowthBook instance to feature changes
function _refreshFeatures() {
  _refreshFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(instance, timeout, skipCache, allowStale, updateInstance, backgroundSync) {
    var data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!backgroundSync) {
            cacheSettings.backgroundSync = false;
          }
          _context2.next = 3;
          return fetchFeaturesWithCache(instance, allowStale, timeout, skipCache);
        case 3:
          data = _context2.sent;
          _context2.t0 = updateInstance && data;
          if (!_context2.t0) {
            _context2.next = 8;
            break;
          }
          _context2.next = 8;
          return refreshInstance(instance, data);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _refreshFeatures.apply(this, arguments);
}
export function subscribe(instance) {
  var key = getKey(instance);
  var subs = subscribedInstances.get(key) || new Set();
  subs.add(instance);
  subscribedInstances.set(key, subs);
}
export function unsubscribe(instance) {
  subscribedInstances.forEach(function (s) {
    return s.delete(instance);
  });
}
export function onHidden() {
  streams.forEach(function (channel) {
    if (!channel) return;
    channel.state = "idle";
    disableChannel(channel);
  });
}
export function onVisible() {
  streams.forEach(function (channel) {
    if (!channel) return;
    if (channel.state !== "idle") return;
    enableChannel(channel);
  });
}

// Private functions
function updatePersistentCache() {
  return _updatePersistentCache.apply(this, arguments);
}
function _updatePersistentCache() {
  _updatePersistentCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          if (polyfills.localStorage) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return");
        case 3:
          _context3.next = 5;
          return polyfills.localStorage.setItem(cacheSettings.cacheKey, JSON.stringify(Array.from(cache.entries())));
        case 5:
          _context3.next = 9;
          break;
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _updatePersistentCache.apply(this, arguments);
}
function fetchFeaturesWithCache(_x7, _x8, _x9, _x10) {
  return _fetchFeaturesWithCache.apply(this, arguments);
}
function _fetchFeaturesWithCache() {
  _fetchFeaturesWithCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(instance, allowStale, timeout, skipCache) {
    var key, cacheKey, now, minStaleAt, existing;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          key = getKey(instance);
          cacheKey = getCacheKey(instance);
          now = new Date();
          minStaleAt = new Date(now.getTime() - cacheSettings.maxAge + cacheSettings.staleTTL);
          _context4.next = 6;
          return initializeCache();
        case 6:
          existing = cache.get(cacheKey);
          if (!(existing && !skipCache && (allowStale || existing.staleAt > now) && existing.staleAt > minStaleAt)) {
            _context4.next = 13;
            break;
          }
          // Restore from cache whether SSE is supported
          if (existing.sse) supportsSSE.add(key);

          // Reload features in the background if stale
          if (existing.staleAt < now) {
            fetchFeatures(instance);
          }
          // Otherwise, if we don't need to refresh now, start a background sync
          else {
            startAutoRefresh(instance);
          }
          return _context4.abrupt("return", existing.data);
        case 13:
          _context4.next = 15;
          return promiseTimeout(fetchFeatures(instance), timeout);
        case 15:
          return _context4.abrupt("return", _context4.sent);
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchFeaturesWithCache.apply(this, arguments);
}
function getKey(instance) {
  var _instance$getApiInfo = instance.getApiInfo(),
    _instance$getApiInfo2 = _slicedToArray(_instance$getApiInfo, 2),
    apiHost = _instance$getApiInfo2[0],
    clientKey = _instance$getApiInfo2[1];
  return "".concat(apiHost, "||").concat(clientKey);
}
function getCacheKey(instance) {
  var baseKey = getKey(instance);
  if (!instance.isRemoteEval()) return baseKey;
  var attributes = instance.getAttributes();
  var cacheKeyAttributes = instance.getCacheKeyAttributes() || Object.keys(instance.getAttributes());
  var ca = {};
  cacheKeyAttributes.forEach(function (key) {
    ca[key] = attributes[key];
  });
  var fv = instance.getForcedVariations();
  var url = instance.getUrl();
  return "".concat(baseKey, "||").concat(JSON.stringify({
    ca: ca,
    fv: fv,
    url: url
  }));
}

// Guarantee the promise always resolves within {timeout} ms
// Resolved value will be `null` when there's an error or it takes too long
// Note: The promise will continue running in the background, even if the timeout is hit
function promiseTimeout(promise, timeout) {
  return new Promise(function (resolve) {
    var resolved = false;
    var timer;
    var finish = function finish(data) {
      if (resolved) return;
      resolved = true;
      timer && clearTimeout(timer);
      resolve(data || null);
    };
    if (timeout) {
      timer = setTimeout(function () {
        return finish();
      }, timeout);
    }
    promise.then(function (data) {
      return finish(data);
    }).catch(function () {
      return finish();
    });
  });
}

// Populate cache from localStorage (if available)
function initializeCache() {
  return _initializeCache.apply(this, arguments);
} // Enforce the maxEntries limit
function _initializeCache() {
  _initializeCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var value, parsed, cleanupFn;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!cacheInitialized) {
            _context5.next = 2;
            break;
          }
          return _context5.abrupt("return");
        case 2:
          cacheInitialized = true;
          _context5.prev = 3;
          if (!polyfills.localStorage) {
            _context5.next = 9;
            break;
          }
          _context5.next = 7;
          return polyfills.localStorage.getItem(cacheSettings.cacheKey);
        case 7:
          value = _context5.sent;
          if (value) {
            parsed = JSON.parse(value);
            if (parsed && Array.isArray(parsed)) {
              parsed.forEach(function (_ref4) {
                var _ref7 = _slicedToArray(_ref4, 2),
                  key = _ref7[0],
                  data = _ref7[1];
                cache.set(key, _objectSpread({}, data, {
                  staleAt: new Date(data.staleAt)
                }));
              });
            }
            cleanupCache();
          }
        case 9:
          _context5.next = 13;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](3);
        case 13:
          if (!cacheSettings.disableIdleStreams) {
            cleanupFn = helpers.startIdleListener();
            if (cleanupFn) {
              helpers.stopIdleListener = cleanupFn;
            }
          }
        case 14:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[3, 11]]);
  }));
  return _initializeCache.apply(this, arguments);
}
function cleanupCache() {
  var entriesWithTimestamps = Array.from(cache.entries()).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return {
      key: key,
      staleAt: value.staleAt.getTime()
    };
  }).sort(function (a, b) {
    return a.staleAt - b.staleAt;
  });
  var entriesToRemoveCount = Math.min(Math.max(0, cache.size - cacheSettings.maxEntries), cache.size);
  for (var i = 0; i < entriesToRemoveCount; i++) {
    cache.delete(entriesWithTimestamps[i].key);
  }
}

// Called whenever new features are fetched from the API
function onNewFeatureData(key, cacheKey, data) {
  // If contents haven't changed, ignore the update, extend the stale TTL
  var version = data.dateUpdated || "";
  var staleAt = new Date(Date.now() + cacheSettings.staleTTL);
  var existing = cache.get(cacheKey);
  if (existing && version && existing.version === version) {
    existing.staleAt = staleAt;
    updatePersistentCache();
    return;
  }

  // Update in-memory cache
  cache.set(cacheKey, {
    data: data,
    version: version,
    staleAt: staleAt,
    sse: supportsSSE.has(key)
  });
  cleanupCache();
  // Update local storage (don't await this, just update asynchronously)
  updatePersistentCache();

  // Update features for all subscribed GrowthBook instances
  var instances = subscribedInstances.get(key);
  instances && instances.forEach(function (instance) {
    return refreshInstance(instance, data);
  });
}
function refreshInstance(_x11, _x12) {
  return _refreshInstance.apply(this, arguments);
}
function _refreshInstance() {
  _refreshInstance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(instance, data) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return instance.decryptPayload(data, undefined, polyfills.SubtleCrypto);
        case 2:
          data = _context6.sent;
          _context6.next = 5;
          return instance.refreshStickyBuckets(data);
        case 5:
          instance.setFeatures(data.features || instance.getFeatures());
          instance.setExperiments(data.experiments || instance.getExperiments());
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _refreshInstance.apply(this, arguments);
}
function fetchFeatures(_x13) {
  return _fetchFeatures.apply(this, arguments);
} // Watch a feature endpoint for changes
// Will prefer SSE if enabled, otherwise fall back to cron
function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(instance) {
    var _instance$getApiHosts2, apiHost, apiRequestHeaders, clientKey, remoteEval, key, cacheKey, promise, fetcher;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _instance$getApiHosts2 = instance.getApiHosts(), apiHost = _instance$getApiHosts2.apiHost, apiRequestHeaders = _instance$getApiHosts2.apiRequestHeaders;
          clientKey = instance.getClientKey();
          remoteEval = instance.isRemoteEval();
          key = getKey(instance);
          cacheKey = getCacheKey(instance);
          promise = activeFetches.get(cacheKey);
          if (!promise) {
            fetcher = remoteEval ? helpers.fetchRemoteEvalCall({
              host: apiHost,
              clientKey: clientKey,
              payload: {
                attributes: instance.getAttributes(),
                forcedVariations: instance.getForcedVariations(),
                forcedFeatures: Array.from(instance.getForcedFeatures().entries()),
                url: instance.getUrl()
              },
              headers: apiRequestHeaders
            }) : helpers.fetchFeaturesCall({
              host: apiHost,
              clientKey: clientKey,
              headers: apiRequestHeaders
            }); // TODO: auto-retry if status code indicates a temporary error
            promise = fetcher.then(function (res) {
              if (!res.ok) {
                throw new Error("HTTP error: ".concat(res.status));
              }
              if (res.headers.get("x-sse-support") === "enabled") {
                supportsSSE.add(key);
              }
              return res.json();
            }).then(function (data) {
              onNewFeatureData(key, cacheKey, data);
              startAutoRefresh(instance);
              activeFetches.delete(cacheKey);
              return data;
            }).catch(function (e) {
              process.env.NODE_ENV !== "production" && instance.log("Error fetching features", {
                apiHost: apiHost,
                clientKey: clientKey,
                error: e ? e.message : null
              });
              activeFetches.delete(cacheKey);
              return Promise.resolve({});
            });
            activeFetches.set(cacheKey, promise);
          }
          _context7.next = 9;
          return promise;
        case 9:
          return _context7.abrupt("return", _context7.sent);
        case 10:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _fetchFeatures.apply(this, arguments);
}
function startAutoRefresh(instance) {
  var key = getKey(instance);
  var cacheKey = getCacheKey(instance);
  var _instance$getApiHosts = instance.getApiHosts(),
    streamingHost = _instance$getApiHosts.streamingHost,
    streamingHostRequestHeaders = _instance$getApiHosts.streamingHostRequestHeaders;
  var clientKey = instance.getClientKey();
  if (cacheSettings.backgroundSync && supportsSSE.has(key) && polyfills.EventSource) {
    if (streams.has(key)) return;
    var channel = {
      src: null,
      host: streamingHost,
      clientKey: clientKey,
      headers: streamingHostRequestHeaders,
      cb: function cb(event) {
        try {
          if (event.type === "features-updated") {
            var instances = subscribedInstances.get(key);
            instances && instances.forEach(function (instance) {
              fetchFeatures(instance);
            });
          } else if (event.type === "features") {
            var json = JSON.parse(event.data);
            onNewFeatureData(key, cacheKey, json);
          }
          // Reset error count on success
          channel.errors = 0;
        } catch (e) {
          process.env.NODE_ENV !== "production" && instance.log("SSE Error", {
            streamingHost: streamingHost,
            clientKey: clientKey,
            error: e ? e.message : null
          });
          onSSEError(channel);
        }
      },
      errors: 0,
      state: "active"
    };
    streams.set(key, channel);
    enableChannel(channel);
  }
}
function onSSEError(channel) {
  if (channel.state === "idle") return;
  channel.errors++;
  if (channel.errors > 3 || channel.src && channel.src.readyState === 2) {
    // exponential backoff after 4 errors, with jitter
    var delay = Math.pow(3, channel.errors - 3) * (1000 + Math.random() * 1000);
    disableChannel(channel);
    setTimeout(function () {
      if (["idle", "active"].includes(channel.state)) return;
      enableChannel(channel);
    }, Math.min(delay, 300000)); // 5 minutes max
  }
}
function disableChannel(channel) {
  if (!channel.src) return;
  channel.src.onopen = null;
  channel.src.onerror = null;
  channel.src.close();
  channel.src = null;
  if (channel.state === "active") {
    channel.state = "disabled";
  }
}
function enableChannel(channel) {
  channel.src = helpers.eventSourceCall({
    host: channel.host,
    clientKey: channel.clientKey,
    headers: channel.headers
  });
  channel.state = "active";
  channel.src.addEventListener("features", channel.cb);
  channel.src.addEventListener("features-updated", channel.cb);
  channel.src.onerror = function () {
    return onSSEError(channel);
  };
  channel.src.onopen = function () {
    channel.errors = 0;
  };
}
function destroyChannel(channel, key) {
  disableChannel(channel);
  streams.delete(key);
}
function clearAutoRefresh() {
  // Clear list of which keys are auto-updated
  supportsSSE.clear();

  // Stop listening for any SSE events
  streams.forEach(destroyChannel);

  // Remove all references to GrowthBook instances
  subscribedInstances.clear();

  // Run the idle stream cleanup function
  helpers.stopIdleListener();
}